namespace TabAurous.ECommerce {
    export namespace ECommSalesReturnItemsBOMService {
        export const baseUrl = 'ECommerce/ECommSalesReturnItemsBOM';

        export declare function Create(request: Serenity.SaveRequest<ECommSalesReturnItemsBOMRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ECommSalesReturnItemsBOMRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ECommSalesReturnItemsBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ECommSalesReturnItemsBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "ECommerce/ECommSalesReturnItemsBOM/Create",
            Update = "ECommerce/ECommSalesReturnItemsBOM/Update",
            Delete = "ECommerce/ECommSalesReturnItemsBOM/Delete",
            Retrieve = "ECommerce/ECommSalesReturnItemsBOM/Retrieve",
            List = "ECommerce/ECommSalesReturnItemsBOM/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ECommSalesReturnItemsBOMService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
